module.exports = __webpack_public_path__ + "static/vuodenyrittajanainen.0bedac2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vuodenyrittajanainen.jpg
// module id = 859
// module chunks = 35783957827783